// NOTE — `font` and `fontFamily` are DELIBERATELY absent here. The TBC
// Contractica Georgian faces and the TBCContractica-first `smbls` stack
// moved to company/packages/brand (designSystem/font.js +
// designSystem/font_family.js, Nika 2026-09-02 "move to brand"), and this
// shell inherits them through the shared-library merge: smbls's
// mergeSharedLibraries runs deepDefaults(context.designSystem,
// brand.designSystem), so brand fills both keys here. Re-declaring either
// key in this file would shadow brand for the whole shell.
import color from './color.js'
import gradient from './gradient.js'
import theme from './theme.js'
import typography from './typography.js'
import spacing from './spacing.js'
import sizes from './sizes.js'
import timing from './timing.js'
import class_ from './class.js'
import grid from './grid.js'
import icons from './icons.js'
import shape from './shape.js'
import reset from './reset.js'
import animation from './animation.js'
import media from './media.js'
export default {
  color,
  gradient,
  theme,
  typography,
  spacing,
  sizes,
  timing,
  class: class_,
  grid,
  icons,
  shape,
  reset,
  animation,
  media
}
